import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service | IntelliEats';
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-891">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-892">
        <header className="mb-12" data-id="element-893">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-894">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-895" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-896">
            <div className="bg-accent-100 text-accent-600 p-3 rounded-2xl" data-id="element-897">
              <FileText className="w-8 h-8" data-id="element-898" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-899">
              Terms of Service
            </h1>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-900">Last updated: April 7, 2025</p>
        </header>

        <div className="space-y-10 text-slate-700 leading-relaxed" data-id="element-901">
          <section data-id="element-902">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-903">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-904">
              By downloading, installing, or using the IntelliEats mobile
              application ("App"), you agree to be bound by these Terms of
              Service ("Terms"). If you do not agree to these Terms, please do
              not use the App.
            </p>
          </section>

          <section data-id="element-905">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-906">
              2. Description of Service
            </h2>
            <p data-id="element-907">
              IntelliEats is a mobile application that uses AI technology to
              scan and analyze ingredient labels on packaged food products. The
              App categorizes ingredients into "Safe," "Limited Intake," and
              "Ingredients to Avoid" based on available nutritional research and
              databases.
            </p>
          </section>

          <section data-id="element-908">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-909">
              3. Disclaimer
            </h2>
            <div className="bg-accent-50 rounded-2xl p-6 border border-accent-100" data-id="element-910">
              <p className="m-0 font-medium text-slate-800" data-id="element-911">
                <strong data-id="element-912">Important:</strong> IntelliEats is designed for
                informational purposes only and should not be considered medical
                or nutritional advice. The ingredient analysis provided by the
                App is based on general nutritional guidelines and may not
                account for individual health conditions, allergies, or dietary
                needs. Always consult with a qualified healthcare professional
                before making significant dietary changes.
              </p>
            </div>
          </section>

          <section data-id="element-913">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-914">
              4. User Responsibilities
            </h2>
            <ul className="space-y-3 list-none p-0" data-id="element-915">
              <li className="flex items-start gap-3" data-id="element-916">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-917"></span>
                <span data-id="element-918">
                  You are responsible for ensuring the accuracy of scanned
                  images and labels
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-919">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-920"></span>
                <span data-id="element-921">
                  You agree not to use the App for any unlawful purpose
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-922">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-923"></span>
                <span data-id="element-924">
                  You acknowledge that scan results depend on image quality and
                  label clarity
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-925">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-926"></span>
                <span data-id="element-927">
                  You agree not to reverse engineer, decompile, or disassemble
                  the App
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-928">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-929">
              5. Intellectual Property
            </h2>
            <p data-id="element-930">
              All content, features, and functionality of the App—including but
              not limited to text, graphics, logos, icons, and software—are the
              exclusive property of IntelliEats and are protected by
              international copyright, trademark, and other intellectual
              property laws.
            </p>
          </section>

          <section data-id="element-931">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-932">
              6. Limitation of Liability
            </h2>
            <p data-id="element-933">
              To the fullest extent permitted by applicable law, IntelliEats and
              its developer shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages arising out of or
              related to your use of the App. This includes, but is not limited
              to, any health-related decisions made based on the App's analysis.
            </p>
          </section>

          <section data-id="element-934">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-935">
              7. Pricing
            </h2>
            <p data-id="element-936">
              The ingredient scanning feature of IntelliEats is free to use.
              Customization features may be available at a minimum cost. We
              reserve the right to modify pricing with reasonable notice to
              users.
            </p>
          </section>

          <section data-id="element-937">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-938">
              8. Termination
            </h2>
            <p data-id="element-939">
              We reserve the right to terminate or suspend your access to the
              App at any time, without prior notice, for conduct that we believe
              violates these Terms or is harmful to other users, us, or third
              parties.
            </p>
          </section>

          <section data-id="element-940">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-941">
              9. Changes to Terms
            </h2>
            <p data-id="element-942">
              We reserve the right to modify these Terms at any time. Continued
              use of the App after changes constitutes acceptance of the revised
              Terms.
            </p>
          </section>

          <section className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-943">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-944">
              10. Contact Us
            </h2>
            <p className="mb-4" data-id="element-945">
              If you have any questions about these Terms, please contact us:
            </p>
            <p className="font-medium text-slate-900" data-id="element-946">
              Email:{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 transition-colors" data-id="element-947">
                intellieats@gmail.com
              </a>
            </p>
            <p className="mt-2" data-id="element-948">
              Or use our{' '}
              <Link to="/contact" className="text-brand-600 hover:text-brand-700 font-medium transition-colors" data-id="element-949">
                Contact Support
              </Link>{' '}
              page.
            </p>
          </section>
        </div>
      </div>
    </motion.div>;
}